import script from "./FlipPropertyReady.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlipPropertyReady.vue?vue&type=script&lang=ts&setup=true"

import "./FlipPropertyReady.vue?vue&type=style&index=0&id=5d49776c&lang=scss"

const __exports__ = script;

export default __exports__